import { CreateQuestionnaireQuestionBulkInput, CreateQuestionnaireQuestionInput } from '@/models/gen/graphql';

import { CreateQuestionnaireQuestionBulkDocument } from '@/api/queries';
import graphApi from '@/api';
import { searchQuestionsWithMetadata } from './searchQuestionnaireQuestions';

const [runCreateQuestion] = graphApi(CreateQuestionnaireQuestionBulkDocument);

export const createQuestion = async (question: Omit<CreateQuestionnaireQuestionInput, 'active' | 'sortOrder'>) => {
  // Sort order continues from the highest sortOrder already used in this category, not just a
  // count of existing questions - deletions can leave gaps, and counting would risk a collision.
  const { questions } = await searchQuestionsWithMetadata([question?.questionnaireCategoryId]);
  const latestSortOrder = (questions || []).reduce((max, { sortOrder }) => Math.max(max, sortOrder || 0), 0);
  const input: CreateQuestionnaireQuestionBulkInput = {
    values: [{ ...question, active: 1, sortOrder: latestSortOrder + 1 }],
  };
  const res = await runCreateQuestion({ input });
  return res?.createQuestionnaireQuestionBulk?.output?.map(({ node }) => node) || [];
};

export default createQuestion;
